const Warning = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12.5" cy="12" r="10" stroke="#FFA000" strokeWidth="2" />
    <path
      d="M12.5 7L12.5 12"
      stroke="#FFA000"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="12.5" cy="16" r="1" fill="#FFA000" />
  </svg>
);
export default Warning;
